module.exports = __webpack_public_path__ + "static/media/network-health.493ab1c6.svg";